module.exports = __webpack_public_path__ + "static/media/family_doctor.cbefe6e2.jpg";